import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../assets/styles/ServiceCategoryCard.module.css';

const ServiceCategoryCard = ({ icon, title, description, path }) => {
  return (
    <Link to={path} className={styles.serviceCategoryCard}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <div className={styles.learnMoreButton}>
        <div className={styles.buttonText}>Learn More</div>
        <div className={styles.buttonArrow}>→</div>
      </div>
    </Link>
  );
};

export default ServiceCategoryCard;